/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toolbar_Secondary_Import_Media_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Import Media" |
*
* @param {Toolbar_Secondary_Import_Media_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const toolbar_secondary_import_media_aria_label = /** @type {((inputs?: Toolbar_Secondary_Import_Media_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toolbar_Secondary_Import_Media_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importation de Média")
	if (locale === "de") return /** @type {LocalizedString} */ ("Importmedien")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importa media")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импорт медиафайлов")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importar medios")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("进口媒体")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メディアのインポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आयात मीडिया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importar mídia")
	return /** @type {LocalizedString} */ ("Import Media")
});